<div class="flex flex-col items-center justify-between m-4">
  <div
    class="flex flex-row items-center justify-center !bg-primary-accumin-purple-100 !text-primary-accumin-white mr-2 !h-10 !w-10 rounded-full"
  >
    <mat-icon svgIcon="icn-user" class="mat-icon-svg-color-white" />
  </div>
  <div>
    <h3 class="text-xl text-accumin-berry-100">
      {{ initData().displayUserName }}
    </h3>
  </div>
  <span class="text-xs">{{ initData().mail }}</span>
  @if (hasShopPermission()) {
    <div class="flex flex-col justify-center items-center bg-primary-accumin-black-05 rounded-lg w-full mt-2">
      <h5 class="font-semibold mt-1">
        {{ "Title.SubTitle.Quota" | transloco }}
      </h5>
      <div class="flex flex-row justify-center font-semibold">
        <div>{{ quota() }}</div>
      </div>
    </div>
  }
  <div class="mt-4 w-full">
    @if (hasAppSynchronizationPermission()) {
      <mat-divider />
      <button mat-menu-item (click)="emitShowMobileTAN()">
        <span>{{ "Module.Option.App.MobileTAN" | transloco }}</span>
      </button>
    }
    @if (hasShopPermission()) {
      <mat-divider />
      <button mat-menu-item (click)="emitShowPackageOverview()">
        <span>{{ "Button.Reception.PurchaseHistory" | transloco }}</span>
      </button>
      <mat-divider />
      <button mat-menu-item (click)="redeemCode.emit()">
        <span>{{ "Button.Reception.RedeemCode" | transloco }}</span>
      </button>
    }
    @if (hasChangeRightPermission()) {
      <mat-divider />
      <button mat-menu-item color="accent" (click)="emitChangeRight()">
        {{ "Module.Internal.ChangeUser" | transloco }}
      </button>
      <mat-divider />
    }
  </div>
  <div class="my-4">
    <h5 class="mt-1">{{ "Module.Header.Support" | transloco }}</h5>
    <p class="mb-1 text-p2b text-primary-accumin-purple-100">
      {{ "Table.Header.PhoneNumber" | transloco }} : {{ initData().supportInformation.phoneNumber }}
    </p>
    <div class="flex flex-row">
      <p class="mb-1 mr-1 text-p2b text-primary-accumin-purple-100"> {{ "Table.Header.Email" | transloco }}: </p>
      <p class="text-p2b text-primary-accumin-purple-100">
        @if (locale() === "de") {
          <a
            class="e-mail text-accumin-berry-100"
            [href]="
              'mailto:' + initData().supportInformation.email + '?subject=Anfrage zu ' + (hasShopPermission() ? 'my Accumate' : 'Accumate')
            "
            >{{ initData().supportInformation.email }}</a
          >
        }
        @if (locale() !== "de") {
          <a
            class="e-mail"
            [href]="
              'mailto:' + initData().supportInformation.email + '?subject=Request to ' + (hasShopPermission() ? 'my Accumate' : 'Accumate')
            "
            >{{ initData().supportInformation.email }}</a
          >
        }
      </p>
    </div>
  </div>
  <mat-divider />
  <button mat-menu-item class="y-4 self-start" (click)="emitLogout()">
    <mat-icon svgIcon="icn-logout" class="mat-icon-svg-color-accumin-purple" />
    <span>{{ "Module.Option.Logout" | transloco }}</span>
  </button>
  <div class="text-xs flex flex-row justify-between items-center w-full ml-2 text-primary-accumin-black-50">
    <div>Accumate</div>
    <div>{{ initData().version }}</div>
  </div>
</div>
